import React from 'react'
import PropTypes from 'prop-types'
import DefaultHeader from './header'
import Payment from './payment'
import Footer from './footer'

const Default = ({
  id,
  title,
  status,
  location,
  locationSlug,
  noOfPasses,
  startDate,
  endDate,
  isRecurrent,
  nextBill,
  price,
}) => (
  <div className="w-full md:w-1/2">
    <div className="shadow-md bg-white m-5 p-5">
      <DefaultHeader
        title={title}
        status={status}
        location={location}
        noOfPasses={noOfPasses}
        startDate={startDate}
        endDate={endDate}
      />
      <div className="mt-10">
        <div className="flex flex-col justify-center items-center">
          {status === 'active' && (
            <Payment title={title} isRecurrent={isRecurrent} nextBill={nextBill} price={price} />
          )}
          <a
            className={`flex justify-center w-3/4 py-3 rounded-lg text-sm font-semibold ${
              status === 'expired' ? 'bg-form-disabled text-primary-darkgray cursor-not-allowed' : 'bg-primary-orange text-white'
            }`}
            href={`/passport-listing/${locationSlug}`}
          >
            Book a Space
          </a>
          <Footer status={status} locationSlug={locationSlug} id={id}/>
        </div>
      </div>
    </div>
  </div>
)

Default.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  location: PropTypes.string,
  locationSlug: PropTypes.string,
  noOfPasses: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  isRecurrent: PropTypes.bool,
  nextBill: PropTypes.string,
  price: PropTypes.string.isRequired,
}

export default Default
